import gql from 'graphql-tag'

export default gql`query participants(
  $filter: FilterFindManyParticipantInput
  $skip: Int
  $limit: Int
  $sort: SortFindManyParticipantInput
) {
  participants(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    _id
    eventId
    firstname
    lastname
    ageCategory
    displayName
    gender
    row
    bib
    shirt {
      type
      size
    }
    lastActivity {
      status
    }
  }
}`
